import {Injectable} from '@angular/core';
import {DetaillineDTOModel} from '../models/detaillineDTO.model';
import {LokijsService} from './database/lokijs.service';
import {CollectionsNames} from '../definitions/collections-names';
import {StateManagerService} from './state-manager.service';

@Injectable({
    providedIn: 'root'
})
export class ScannedTodayService {

    constructor(private collectionsNames: CollectionsNames,
                private loki: LokijsService,
                private stateManagerService: StateManagerService) {
    }

    check(detailLines: DetaillineDTOModel[]): DetaillineDTOModel[] {
        const todayString = new Date().toISOString().substring(0, 10);
        let scannedToday = this.loki.getCollection(this.collectionsNames.SCANNEDBARCODES).chain().data();
        console.log(scannedToday);
        if (scannedToday && scannedToday.length > 0) {
            scannedToday = scannedToday.filter(scan => {
                return scan.date.substring(0, 10) === todayString;
            });
            detailLines.forEach(line => {
                scannedToday.forEach(scanned => {
                    if (line.barcode === scanned.barcode) {
                        line.isChecked = true;
                    }
                });
            });
        }
        return detailLines;
    }
}
